var React = require('react');

function ArrowGrowPurple (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#5B00DB","strokeWidth":"2","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},[React.createElement("path",{"d":"M18 7h3v3","key":0}),React.createElement("path",{"d":"m4 17 6.376-5.715 4.25 2.143L21 7","key":1})]));
}

ArrowGrowPurple.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = ArrowGrowPurple;

ArrowGrowPurple.default = ArrowGrowPurple;
